import { render, staticRenderFns } from "./app-cosmetic-grade.vue?vue&type=template&id=df5941fc&"
import script from "./app-cosmetic-grade.vue?vue&type=script&lang=js&"
export * from "./app-cosmetic-grade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports